export default "__VITE_ASSET__BZ2Uc3Ft__"